import { Component, OnInit, Input } from '@angular/core';
import { StorageFees } from '../../model/staterequirements.model';

@Component({
  selector: 'app-state-requirement-storagefee',
  templateUrl: './state-requirement-storagefee.component.html',
  styleUrls: ['./state-requirement-storagefee.component.css']
})
export class StateRequirementStoragefeeComponent implements OnInit {
  public role: string;
  public showFlag: boolean = false;
  private _storageFees: StorageFees;
  public parClicked: any;
  public agentClicked: any;
  clientDisable: any;
  clientHidden: any;
  public get storageFees(): StorageFees {
    return this._storageFees;
  }

  @Input()
  public set storageFees(value: StorageFees) {
    if (typeof value !== 'undefined' && value !== null) {
      this._storageFees = value;
    }
    else {
      this._storageFees = new StorageFees();
    }

  }

  constructor() {

    this._storageFees = new StorageFees();
  }

  ngOnInit() {
    this.role = localStorage.getItem("Role");
    this.parClicked = localStorage.getItem("parClicked");
    this.agentClicked = localStorage.getItem("agentClicked");
    if (this.role === "PC PAR Vendor Relations" || this.role === "PC Client" && (this.agentClicked ==="false" && this.parClicked === "false")) {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC Client" && this.parClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.agentClicked === "true") {
      this.showFlag = true;
    }
    else if (this.role === "PC PAR Admin" && this.parClicked === "true") {
      this.showFlag = false;
    }
    else {
      this.showFlag = false;
    }

    this.role = localStorage.getItem("Role");
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/state-requirement-storagefee/state-requirement-storagefee.component.ts